import React from "react";
import Link from "next/link";
import { viewport, font, lineHeight } from "@styles/cssinjs/helpers/variables";
import { replaceHrefInAnswer } from "../common/SignupUrlReplacer";

type BadgeItem = {
  href: string;
  title: string;
  desc: string;
  image: HTMLImageElement;
};

type BadgeCardProps = {
  data: {
    title: string;
    desc: string;
    list: BadgeItem[];
    moreBadges: {
      desc: string;
    };
  };
};

const BadgeCard = ({ data }: BadgeCardProps) => {
  return (
    <section className="container lg:pt-10 lg:pb-10 md:pt-5 md:pb-2.5 img-wd-mob">
      <article className="lg:maxw-lg mx-auto lg:text-center md:text-center">
        <h2 className="text-lg">{data.title}</h2>
        <p
          className="lg:mt-3 lg:px-5 md:mt-2"
          dangerouslySetInnerHTML={{ __html: data.desc }}
        />
      </article>
      <div className="lg:mt-10 md:mt-5 card--default card--showcase has-two-col has-gutter-md">
        {data.list.map((item, index) => {
          return (
            <Link
              className="hover-review-card"
              href={item.href}
              key={index}
              prefetch={false}
            >
              <div>
                <h3 className="lg:mb-3 lg:mt-5 md:mb-1.5">{item.title}</h3>
                <p dangerouslySetInnerHTML={{ __html: item.desc }} />
              </div>
              <figure>
                <img
                  src={item.image.src}
                  alt={item.image.alt}
                  loading="lazy"
                  width="128"
                  height="200"
                />
              </figure>
              <style global jsx>
                {`
                  .hover-review-card p {
                    font-size: ${font.size.md[1]};
                    line-height: ${lineHeight[6]};
                    max-width: 300px;
                    margin-bottom: 24px;
                  }
                  @media (min-width: ${viewport.tablet.sm}) {
                    .hover-review-card {
                      max-height: 248px;
                      cursor: pointer;
                      display: flex;
                    }
                    .hover-review-card figure {
                      margin-left: auto;
                    }
                  }
                  @media (max-width: ${viewport.tablet.sm}) {
                    .hover-review-card {
                      flex-direction: column;
                    }
                  }
                `}
              </style>
            </Link>
          );
        })}
        <div className="bg-light boxshadow-none hover-review-card text-center">
          <p
            className="lg:py-9 lg:mx-10 md:m-0"
            dangerouslySetInnerHTML={{
              __html: replaceHrefInAnswer(data.moreBadges.desc),
            }}
          />
        </div>
      </div>
    </section>
  );
};

export default BadgeCard;
